import { useGlobalContext } from "@/context/globalContext";
import React from "react";
import BottomBar from "./BottomBar";
import BottomContent from "./BottomContent";
import FooterBottom from "./Footer/FooterBottom";
import Image from "next/image";
import { useIntersectionObserver } from "@/hooks/useIntersectionObserver";
import dynamic from "next/dynamic";

const ContactSection = dynamic(() => import("./Footer/ContactSection"));
const FeatureSection = dynamic(() => import("./Footer/FeatureSection"));
const FooterInfo = dynamic(() => import("./Footer/FooterInfo"));
const CreditCardInfo = dynamic(() => import("./Footer/CreditCardInfo"));
const WhatsappSupport = dynamic(() => import("./Footer/WhatsappSupport"));

const Footer = ({
  dataFooter,
  RoutingController,
  dataHeader,
  RoutingTypeId,
  data,
}) => {
  const { zIndex, mobileBar } = useGlobalContext();
  const [sectionRef, isVisible] = useIntersectionObserver();

  return (
    <footer>
      <div ref={sectionRef}>
        {isVisible && RoutingTypeId != "Reservation" && (
          <>
            <div className="lg:mb-[60px] md:mb-8 mb-4">
              <ContactSection dataFooter={dataFooter} />
            </div>
            <FeatureSection />
            <FooterInfo dataFooter={dataFooter} />
            <div className="xl:container">
              <div className="pb-4 border-b border-[#F3F6F9] block">
                <div className="container">
                  <CreditCardInfo />
                  <div className="flex items-center gap-2">
                    <Image
                      src="/icons/ssl.svg"
                      width={28}
                      height={28}
                      alt="SSL Sertifikası"
                    />
                    <span className="font-normal leading-normal text-themeBlack text-size-13">
                      Bu web sitesi SSL Sertifikası İle Korunmaktadır.
                    </span>
                  </div>
                </div>
              </div>
            </div>
            <FooterBottom RoutingController={RoutingController} />
          </>
        )}
      </div>
      <div
        className={`lg:hidden px-4 w-full flex border-t fixed bottom-0 bg-white justify-between ${
          zIndex ? "z-10" : "z-[52]"
        } `}
      >
        <div className="flex items-end justify-between w-full z-10 bg-white pb-1.5 h-[61px]">
          <BottomBar
            RoutingController={RoutingController}
            dataHeader={dataHeader}
            dataFooter={dataFooter}
            ssr={data}
            RoutingTypeId={RoutingController}
          />
        </div>
        {(RoutingController !== "Detail") &
          (RoutingController !== "Reservation") &&
          !mobileBar && (
            <div className="absolute bottom-0 ml-1 left-1/2 transform -translate-x-1/2 w-24 h-20 rounded-full border-t bg-white" />
          )}
      </div>
      <BottomContent
        dataHeader={dataHeader}
        ssr={data}
        RoutingTypeId={RoutingTypeId}
        RoutingController={RoutingController}
      />
      <WhatsappSupport />
    </footer>
  );
};

export default Footer;
